import { graphql } from "gatsby"

// // base64 for student profile page
// export const CloudImage = graphql`
//   fragment CloudImage on CloudinaryAsset {
//     fluid(maxWidth: 1920) {
//       ...CloudinaryAssetFluid
//     }
//   }
// `
// // base64 for student profile page
// export const GridCloudImage = graphql`
//   fragment GridCloudImage on CloudinaryAsset {
//     fluid(maxWidth: 611) {
//       ...CloudinaryAssetFluid
//     }
//   }
// `

export const cloudinaryImageSelector = node => {
  if (!node) {
    return null
  }
  return node?.cloudinary?.gatsbyImageData
    ? node?.cloudinary?.gatsbyImageData
    : null
}

export const directFilenameImage = filename =>
  `https://studentupload.rca.ac.uk/media/${filename}`
